import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20jur%C3%ADdica';

const differentials = [
  { icon: 'ri-flashlight-line', title: 'Atendimento Rápido', desc: 'Resposta imediata para casos urgentes, pois sabemos que cada minuto importa.' },
  { icon: 'ri-magic-line', title: 'Estratégia Personalizada', desc: 'Cada caso recebe um plano de ação exclusivo, desenvolvido para maximizar resultados.' },
  { icon: 'ri-trophy-line', title: 'Foco em Resultados', desc: 'Nossa reputação é construída com base em resultados concretos e clientes satisfeitos.' },
  { icon: 'ri-heart-line', title: 'Atendimento Humanizado', desc: 'Tratamos cada cliente com empatia e respeito, entendendo o impacto emocional do caso.' },
  { icon: 'ri-shield-star-line', title: 'Especialização Digital', desc: 'Expertise única em crimes digitais, golpes bancários e fraudes financeiras online.' },
  { icon: 'ri-eye-off-line', title: 'Sigilo Absoluto', desc: 'Garantia de total confidencialidade e proteção das informações do seu caso.' },
];

export default function Differentials() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="diferenciais"
      className="py-28 relative overflow-hidden"
      ref={ref}
      style={{ background: '#0B2F5B' }}
    >
      {/* Geometric texture */}
      <div className="absolute inset-0 pointer-events-none opacity-5">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              width: `${120 + i * 80}px`,
              height: `${120 + i * 80}px`,
              border: '1px solid #C9A24A',
              left: `${10 + i * 10}%`,
              top: `${-30 + i * 8}%`,
              opacity: 0.6,
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: title + CTA */}
          <div
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(-40px)',
              transition: 'all 0.7s cubic-bezier(0.4,0,0.2,1)',
            }}
          >
            <span className="text-xs font-bold tracking-widest uppercase mb-4 inline-block" style={{ color: '#C9A24A' }}>
              Por que nos escolher
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
              Advocacia <span style={{ color: '#C9A24A' }}>especializada</span> que entrega resultados
            </h2>
            <p className="text-lg leading-relaxed mb-8" style={{ color: 'rgba(255,255,255,0.75)' }}>
              Somos referência em Franca/SP no combate a golpes bancários e crimes digitais. Nossa abordagem combina rigor técnico-jurídico com atendimento próximo e humanizado.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full font-bold text-base cursor-pointer whitespace-nowrap transition-all duration-300 hover:scale-105"
              style={{ background: '#C9A24A', color: '#0B2F5B', boxShadow: '0 8px 24px rgba(201,162,74,0.35)' }}
            >
              <i className="ri-whatsapp-line text-xl" />
              Falar com Advogado
            </a>
          </div>

          {/* Right: 2x3 grid */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 gap-5"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(40px)',
              transition: 'all 0.7s cubic-bezier(0.4,0,0.2,1) 0.1s',
            }}
          >
            {differentials.map((d, i) => (
              <div
                key={i}
                className="rounded-xl p-6 transition-all duration-300 hover:scale-105"
                style={{
                  background: 'rgba(255,255,255,0.07)',
                  border: '1px solid rgba(201,162,74,0.2)',
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(20px)',
                  transition: `all 0.5s cubic-bezier(0.4,0,0.2,1) ${0.2 + i * 0.07}s`,
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg mb-4" style={{ background: 'rgba(201,162,74,0.15)' }}>
                  <i className={`${d.icon} text-xl`} style={{ color: '#C9A24A' }} />
                </div>
                <h3 className="font-bold text-base text-white mb-2">{d.title}</h3>
                <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.65)' }}>{d.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
